define.alias("shared/components/shared/plan-recommendation/option-card", "calendar/components/shared/plan-recommendation/option-card");